export type ChoirRehearsalSongsGuideStepId = "add_song" | "open_song";

export interface ChoirRehearsalSongsGuideState {
    completed: ChoirRehearsalSongsGuideStepId[];
    dismissed_at: string | null;
    completed_at: string | null;
}

export const CHOIR_REHEARSAL_SONGS_GUIDE_STEPS: ChoirRehearsalSongsGuideStepId[] = [
    "add_song",
    "open_song",
];

export function createDefaultChoirRehearsalSongsGuideState(
    seed?: Partial<ChoirRehearsalSongsGuideState> | null
): ChoirRehearsalSongsGuideState {
    const completed = Array.isArray(seed?.completed)
        ? seed?.completed?.filter((step): step is ChoirRehearsalSongsGuideStepId => (
            CHOIR_REHEARSAL_SONGS_GUIDE_STEPS.includes(step as ChoirRehearsalSongsGuideStepId)
        )) || []
        : [];

    return {
        completed,
        dismissed_at: seed?.dismissed_at ?? null,
        completed_at: seed?.completed_at ?? null,
    };
}

export function getChoirRehearsalSongsGuideSteps(canManageSongs: boolean): ChoirRehearsalSongsGuideStepId[] {
    return canManageSongs
        ? CHOIR_REHEARSAL_SONGS_GUIDE_STEPS
        : ["open_song"];
}

export function getChoirRehearsalSongsGuideNextStep(
    state: ChoirRehearsalSongsGuideState,
    canManageSongs: boolean
): ChoirRehearsalSongsGuideStepId | null {
    const completed = new Set(state.completed || []);
    return getChoirRehearsalSongsGuideSteps(canManageSongs)
        .find((step) => !completed.has(step)) || null;
}

export function isChoirRehearsalSongsGuideStepCompleted(
    state: ChoirRehearsalSongsGuideState,
    step: ChoirRehearsalSongsGuideStepId
): boolean {
    return state.completed.includes(step);
}

export function markChoirRehearsalSongsGuideStep(
    state: ChoirRehearsalSongsGuideState,
    step: ChoirRehearsalSongsGuideStepId,
    activeSteps: ChoirRehearsalSongsGuideStepId[] = CHOIR_REHEARSAL_SONGS_GUIDE_STEPS
): ChoirRehearsalSongsGuideState {
    const relevantSteps = activeSteps.length ? activeSteps : CHOIR_REHEARSAL_SONGS_GUIDE_STEPS;
    if (state.completed.includes(step)) {
        const done = relevantSteps.every((candidate) => state.completed.includes(candidate));
        return done && !state.completed_at
            ? {...state, completed_at: new Date().toISOString()}
            : state;
    }

    const nextCompleted = [...state.completed, step];
    const done = relevantSteps.every((candidate) => nextCompleted.includes(candidate));

    return {
        ...state,
        completed: nextCompleted,
        completed_at: done ? state.completed_at || new Date().toISOString() : state.completed_at,
    };
}
